import { Box, Avatar } from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import EditIcon from "@mui/icons-material/Edit";
import Card from "@mui/material/Card";
import styled, { withTheme } from "styled-components/macro";
import React, { useEffect, useState } from "react";
import moment from "moment";
import Delete from "../../../../components/Models/DeleteModal/Delete";
import { Alert as MuiAlert, TextField } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import DeleteIcon from "@mui/icons-material/Delete";
import Modal from "@mui/material/Modal";
import Skeleton from "@mui/material/Skeleton";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import RepeatIcon from "@mui/icons-material/Repeat";
import { ReactComponent as NoRepeat } from "../../../../assets/Icons/NoRepeat.svg";
import { ReactComponent as Clock } from "../../../../assets/Icons/Clock.svg";
import { ReactComponent as AddLocation } from "../../../../assets/Icons/AdddLoaction.svg";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { ReactComponent as CallNow } from "../../../../assets/Icons/CallNow.svg";
import { ReactComponent as Repeat } from "../../../../assets/Icons/Repeat.svg";
import Company from "../../../../assets/Icons/Company.png";
import { ReactComponent as VertIcon } from "../../../../assets/Icons/VertIcon.svg";

import { spacing } from "@mui/system";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import blurImage from "../../../../assets/placeholder.png";

import {
  Grid,
  IconButton,
  Typography,
  Divider as MuiDivider,
  MenuItem,
  Menu,
  Checkbox,
} from "@mui/material";
import { toast } from "react-toastify";
import { api } from "../../../../contexts/JWTContext";
import { Dialog } from "@material-ui/core";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import EditPosts from "../EditPosts/index";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import { useStyles } from "../styles/style";

const Alert = styled(MuiAlert)(spacing);
function AllPostsCard({
  item,
  getAllposts,
  handlePostChecked,
  index,
  deletePostsArr,
}) {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [anchorMenu, setAnchorMenu] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [totalTimesPosted, setTotalTimesPosted] = useState(0);
  const [maxCount, setMaxCount] = useState(0);
  const [failedPostCount, setFailedPostCount] = useState(0);
  const [deletePost, setDeletePost] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const companyData = JSON.parse(localStorage.getItem("company"));
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (item?.postLocations?.length > 0) {
      let timesPosted = 0;
      let failedTimes = 0;
      item?.postLocations?.forEach((item) => {
        timesPosted = timesPosted + item?.count;
        failedTimes = failedTimes + item?.failCount;
      });
      setTotalTimesPosted(timesPosted);
      setFailedPostCount(failedTimes);
    }
  }, []);

  const handleOpenModal = (id) => {
    setOpenModal(id);
    setAnchorEl(null);
  };
  const handleOpenDeleteModel = (id) => {
    setDeletePost(id);
    setOpen(id);
    setAnchorEl(null);
  };
  const handleCloseModal = () => {
    // setAnchorEl(null);
    setOpenModal(false);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const deletePosts = async (id) => {
    setIsLoading(true);
    try {
      const res = await api.delete(`/post/${id}`);

      if (res.status === 200) {
        getAllposts();
        toast.success("Post Deleted Successfully");
        setOpen(false);
        closeMenu(false);
      }
      setIsLoading(false);
    } catch (error) {}
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxHeight: "99vh",
    width: "720px",
    bgcolor: "background.paper",
    border: "2px solid gray",
    borderRadius: "8px",
    justifyContent: "space-around",
    overflow: "scroll",
    boxShadow: 24,
    p: 4,
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleErrorMessage = (message) => {
    const splitMessage = message.split(",");
    if (splitMessage.length > 0) {
      return `${splitMessage[1]} , ${splitMessage[2]}`;
    }
    return null;
  };
  const handleDisplayDate = (item) => {
    let displayDate = "";
    if (companyData.dateFormat === "May 19,2022 3:05PM") {
      displayDate = moment(item).format("MMMM DD,YYYY LT");
    }
    if (companyData.dateFormat === "Monday,May 19,2022 3:05PM") {
      displayDate = moment(item).format("dddd,MMMM DD,YYYY LT");
    }
    if (companyData.dateFormat === "May 19,2022") {
      displayDate = moment(item).format("MMMM DD,YYYY");
    }
    if (companyData.dateFormat === "5/19/2022") {
      displayDate = moment(item).format("M/D/YYYY");
    }
    if (companyData.dateFormat === "05/19/2022") {
      displayDate = moment(item).format("MM/D/YYYY");
    }
    if (companyData.dateFormat === "28/12/2022") {
      displayDate = moment(item).format("D/MM/YYYY");
    } else {
      displayDate = moment(item).format("D/MM/YYYY");
    }
    if (displayDate.length > 0) {
      return displayDate;
    } else return null;
  };
  return (
    <>
      <Dialog
        // fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <Delete
          title={t("Delete_Post")}
          description={t("del_desc")}
          onConfirm={() => deletePosts(deletePost)}
          onCancel={handleClose}
        />
      </Dialog>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Card className={classes.allPostCard}>
            <Box className={classes.allPostCardBox1}>
              <Box
                sx={{
                  display: "flex",
                }}
              ></Box>
              <Box className={classes.allPostCardBox2}>
                <Modal
                  open={openModal}
                  onClose={handleCloseModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <EditPosts
                      item={item}
                      onCancel={handleCloseModal}
                      getAllposts={getAllposts}
                    />
                  </Box>
                </Modal>
              </Box>
            </Box>

            <Grid container spacing={2} sx={{ padding: "16px" }}>
              {!isMobile && (
                <Grid sm={12} md={0.5} lg={0.5} xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      float: "right",
                      // mt: 2,
                      //  marginRight: "8px",
                    }}
                  >
                    <Checkbox
                      checked={deletePostsArr.includes(item.id)}
                      onChange={(e) => {
                        handlePostChecked(e, index, item.id);
                      }}
                      //   inputProps={{ "aria-label": "controlled" }}
                      label=""
                    />
                  </Box>
                </Grid>
              )}
              {isMobile && (
                <Grid
                  sm={12}
                  md={1}
                  lg={1}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Checkbox
                    checked={deletePostsArr.includes(item.id)}
                    onChange={(e) => {
                      handlePostChecked(e, index, item.id);
                    }}
                    //   inputProps={{ "aria-label": "controlled" }}
                    label=""
                  />

                  <IconButton
                    onClick={handleClick}
                    variant="outlined"
                    color="inherit"
                  >
                    <VertIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    <MenuItem
                      onClick={() => {
                        closeMenu();
                        handleOpenModal(item?.id);
                      }}
                    >
                      <Typography>{t("Edit")}</Typography>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        closeMenu();
                        handleOpenDeleteModel(item?.id);
                        // setOpen();
                        // setDeletePost(item?.id);
                      }}
                    >
                      <Typography>{t("Delete")}</Typography>
                    </MenuItem>
                  </Menu>
                </Grid>
              )}
              <Grid
                item
                sm={12}
                md={4}
                lg={2.5}
                xs={12}
                sx={{
                  display: "row",
                  justifyContent: "center",
                  paddingX: "14px",
                  height: "300px",
                }}
              >
                <LazyLoadImage
                  loading="lazy"
                  src={item?.postPicture?.map((item) => item.url)}
                  width={"100%"}
                  height={200}
                  PlaceholderSrc={blurImage}
                  alt="Image Alt"
                  effect="blur"
                />

                {/* <CardMedia
                component="img"
                sx={{
                  borderRadius: "5%",
                  height: "250px",
                  width: "100%",
                  alignContent: "center",
                }}
                img
                src={item?.postPicture?.map((item) => item.url)}
                alt="image"
              /> */}
              </Grid>
              <Grid item sm={12} md={7} lg={8.5} xs={12}>
                <CardContent
                  sx={{ width: "100%", padding: isMobile ? "16px" : "0px" }}
                >
                  <Box sx={{ marginBottom: "8px", display: "flex" }}>
                    {item?.isPaused === true ? (
                      <Chip
                        sx={{
                          bgcolor: "#1B2430",
                          color: "#ffff",
                          borderRadius: "58px",
                        }}
                        label={t("Paused")}
                      />
                    ) : item?.repeat === "no" &&
                      totalTimesPosted === 0 &&
                      !failedPostCount > 0 ? (
                      <Chip
                        sx={{
                          bgcolor: "#f7c24a",
                          color: "#ffff",
                          borderRadius: "58px",
                        }}
                        label={t("Haven't_Posted_Yet")}
                      />
                    ) : item?.repeat === "no" && item.status === "done" ? (
                      <Chip
                        sx={{
                          bgcolor: "#3dc3ff",
                          color: "#ffff",
                          borderRadius: "58px",
                        }}
                        label={t("Posted")}
                      />
                    ) : item?.repeat !== "no" && totalTimesPosted === 0 ? (
                      <Chip
                        sx={{
                          bgcolor: "#f7c24a",
                          color: "#ffff",
                          borderRadius: "58px",
                        }}
                        label={t("Yet_To_be_Posted")}
                      />
                    ) : item?.repeat !== "no" && totalTimesPosted > 0 ? (
                      <Chip
                        sx={{
                          bgcolor: "#3dc3ff",
                          color: "#ffff",
                          borderRadius: "58px",
                        }}
                        label={`${t("Posted")} ${
                          totalTimesPosted ? totalTimesPosted : "0"
                        } ${t("times")}`}
                      />
                    ) : (
                      // ) : item?.isPaused===true (
                      //   <Chip
                      //     sx={{
                      //       bgcolor: "#3dc3ff",
                      //       color: "#ffff",
                      //       borderRadius: "58px",
                      //     }}
                      //     label={t("Paused")}
                      //     />

                      ""
                      // item?.isPaused===true  && (
                      //   <Chip
                      //   sx={{
                      //     bgcolor: "#FFD0D0",
                      //     color: "#330404",
                      //     borderRadius: "58px",
                      //     marginLeft: "10px",
                      //   }}
                      //   label={t("Paused")}
                      // />
                    )}
                    {failedPostCount > 0 && (
                      <Chip
                        sx={{
                          bgcolor: "#FC3652",
                          color: "#FFFFFF",
                          borderRadius: "58px",
                          marginLeft: "10px",
                        }}
                        label={`${t("Failedd")} ${failedPostCount} ${t(
                          "times"
                        )}`}
                      />
                    )}
                    {/* {item?.isPaused===true  && (
                   <Chip
                   sx={{
                     bgcolor: "#FFD0D0",
                     color: "#330404",
                     borderRadius: "58px",
                     marginLeft: "10px",
                   }}
                   label={t("Paused")}
                 />
                 )}  */}
                  </Box>

                  <Typography className={classes.allpostTitle}>
                    {item?.title}
                  </Typography>

                  <Typography className={classes.allPostContent}>
                    {item?.content}
                  </Typography>

                  <Grid container spacing={4} sx={{ mt: 2 }}>
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <AddLocation />

                        <Typography className={classes.locationAllpost}>
                          {t("Location")}
                          <Typography
                            variant="caption"
                            display="block"
                            className={classes.locationAllpostText}
                          >
                            {item.postLocations.length > 1
                              ? `${t("Multi")}`
                              : `${t("Single")}`}
                          </Typography>
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Clock />

                        <Typography
                          sx={{
                            lineHeight: "24px",
                            fontSize: "16px",
                            fontWeight: "400",
                            color: "#1B2430",
                            paddingX: "4px",
                          }}
                        >
                          {companyData !== null
                            ? handleDisplayDate(item?.startDate)
                            : moment(item?.startDate).format("D/MM/YYYY")}
                          {/*   {moment(item?.startDate).format("MMMM Do YYYY")} */}
                          <Typography
                            variant="caption"
                            display="block"
                            className={classes.allpostDateText}
                          >
                            {moment(item?.startDate).format("ddd, LT")}
                          </Typography>
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      {item?.repeat === "no" ? (
                        <>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <NoRepeat />
                            <Typography
                              variant="caption"
                              display="flex"
                              sx={{
                                lineHeight: "20px",
                                fontSize: "14px",
                                fontWeight: "400",
                                color: "#495059",
                                paddingX: "4px",
                              }}
                            >
                              {t("No_Repeat")}
                            </Typography>
                          </Box>
                        </>
                      ) : (
                        <>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Repeat />
                            <Typography
                              sx={{
                                lineHeight: "24px",
                                fontSize: "16px",
                                fontWeight: "400",
                                color: "#1B2430",
                                paddingX: "4px",
                              }}
                            >
                              {t("Repeat")}: {item?.repeat}
                              <Typography
                                variant="caption"
                                display="block"
                                sx={{
                                  lineHeight: "20px",
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  color: "#495059",
                                  paddingX: "4px",
                                }}
                              >
                                {companyData !== null
                                  ? item?.endDate !== null
                                    ? `${t("Ends_on")} ${handleDisplayDate(
                                        item?.endDate
                                      )}`
                                    : " "
                                  : moment(item?.startDate).format("D/MM/YYYY")}
                              </Typography>
                            </Typography>
                          </Box>
                        </>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img alt="" src={Company} width={40} height={40} />
                        {/*   <Company />
                         ******/}
                        {/* <Chip
                    label={item?.postType}
                    color="secondary"
                    variant="contained"
                    icon={<EditIcon />}
                  /> */}
                        <Typography
                          sx={{
                            lineHeight: "24px",
                            fontSize: "16px",
                            fontWeight: "400",
                            color: "#1B2430",
                            paddingX: "4px",
                          }}
                        >
                          {t("Company_Name")}

                          <Typography
                            variant="caption"
                            display="block"
                            sx={{
                              lineHeight: "20px",
                              fontSize: "14px",
                              fontWeight: "400",
                              color: "#495059",
                              paddingX: "4px",
                              // wordBreak: "break-all",
                            }}
                          >
                            {item?.company !== null ? item?.company?.name : ""}
                          </Typography>
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={8} lg={8}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <CallNow />

                        {/* <Chip
                    label={item?.postType}
                    color="secondary"
                    variant="contained"
                    icon={<EditIcon />}
                  /> */}
                        <Typography
                          sx={{
                            lineHeight: "24px",
                            fontSize: "16px",
                            fontWeight: "400",
                            color: "#1B2430",
                            paddingX: "4px",
                          }}
                        >
                          {`${t("Google_CTA")}: ${
                            item?.postType !== null && item?.postType === "BOOK"
                              ? `${t("Book")}`
                              : item?.postType !== null &&
                                item?.postType === "SHOP"
                              ? `${t("Shop")}`
                              : item?.postType !== null &&
                                item?.postType === "LEARN_MORE"
                              ? `${t("Learn_More")}`
                              : item?.postType !== null &&
                                item?.postType === "ORDER"
                              ? `${t("OrderOnline")}`
                              : item?.postType !== null &&
                                item?.postType === "SIGN_UP"
                              ? `${t("Sign_Up")}`
                              : item?.postType !== null &&
                                item?.postType === "CALL"
                              ? `${t("CallNow")}`
                              : ""
                          }`}

                          <Typography
                            variant="caption"
                            display="block"
                            sx={{
                              lineHeight: "20px",
                              fontSize: "14px",
                              fontWeight: "400",
                              color: "#495059",
                              paddingX: "4px",
                              wordBreak: "break-all",
                            }}
                          >
                            {item?.url ? item?.url : ""}
                          </Typography>
                        </Typography>
                      </Box>
                    </Grid>

                    {/*    <Grid item xs={12} sm={7} md={4} lg={4}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {item?.repeat === "no" ? <NoRepeat /> : <Repeat />}
                    <Typography
                      sx={{
                        lineHeight: "24px",
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#1B2430",
                        paddingX: "4px",
                      }}
                    >
                      {t("Post_Status")}

                      <Typography
                        variant="caption"
                        display="block"
                        sx={{
                          lineHeight: "20px",
                          fontSize: "14px",
                          fontWeight: "400",
                          color: "#495059",
                          paddingX: "4px",
                        }}
                      >
                        {item?.repeat === "no" && item?.count===0
                          ? `${t("Haven't_Posted_Yet")}`
                          : item?.repeat === "no" && item.status === "done"
                          ? `${t("Posted")}`
                          : item?.repeat !== "no" && item?.count===0
                          ? `${t("Haven't_Posted_Yet")}`
                          : item?.repeat !== "no" && item?.count > 0
                          ? `${item.count} ${t("Times_Posted")}`
                          : ""}
                      </Typography>
                    </Typography>
                  </Box>
                </Grid> */}
                    {item.status === "failed" && (
                      <Grid item sm={12} lg={12} md={12} xs={12}>
                        <Grid item sm={12} lg={10} md={10} xs={12}>
                          {/*  <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Alert
                        mt={2}
                        mb={1}
                        severity="error"
                        sx={{ bgcolor: "#FFD0D0", color: "#330404" }}
                      >
                        {handleErrorMessage(item.errorMessage)}
                      </Alert>
                    </Box> */}

                          <Grid
                            container
                            className={classes.mainContainer}
                            onClick={() =>
                              navigate(`/admin/allposts/logs/${item.id}`)
                            }
                          >
                            <Grid item xs={1} sm={1} md={0.5} lg={0.5}>
                              <ErrorOutlineIcon className={classes.errorIcon} />
                            </Grid>
                            <Grid item xs={10} sm={10} md={11} lg={10.5}>
                              <div
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  width: "100%",
                                  // textAlign: "center",
                                  paddingLeft: "10px",
                                }}
                              >
                                <Typography className={classes.errorText}>
                                  {item?.errorMessage}
                                </Typography>
                              </div>
                            </Grid>
                            <Grid item xs={1} sm={1} md={0.5} lg={1}>
                              <KeyboardArrowRightIcon
                                className={classes.arrowIcon}
                                fontSize={"large"}
                                onClick={() =>
                                  navigate(`/admin/allposts/logs/${item.id}`)
                                }
                              />{" "}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </CardContent>
              </Grid>
              {!isMobile && (
                <Grid sm={12} md={0.5} lg={0.5} xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      float: "right",
                      mt: 2,
                      marginRight: "8px",
                    }}
                  >
                    <IconButton
                      onClick={handleClick}
                      variant="outlined"
                      color="inherit"
                    >
                      <VertIcon />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      <MenuItem
                        onClick={() => {
                          closeMenu();
                          handleOpenModal(item?.id);
                        }}
                      >
                        <Typography>{t("Edit")}</Typography>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          closeMenu();
                          handleOpenDeleteModel(item?.id);
                          // setOpen();
                          // setDeletePost(item?.id);
                        }}
                      >
                        <Typography>{t("Delete")}</Typography>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          closeMenu();
                          navigate(`/admin/allposts/logs/${item.id}`);
                        }}
                      >
                        <Typography>{t("Logs")}</Typography>
                      </MenuItem>
                    </Menu>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}

export default AllPostsCard;
